import React, { useContext, useState } from 'react';
import { Parallax } from 'react-parallax';
import YouTubePlayer from './youtubeplayer';
import { Link } from "react-router-dom";
import { AppContext } from '../main';



const Section = (props) => {
    const {
        handleEditItem
    } = props

    const { appState, setAppState
    } = useContext(AppContext);
    const {
        videoanimates = {
            // videoId: 'QB2DfxkaBeU',
            // subtitle: "Servers Are Available",
            // title: "Minecraft Server Hosting",
            // description: "Aute velit non excepteur in eiusmod proident aute qui ullamco incididunt aliqua aliqua velit cillum deserunt dolore consectetur excepteur magna dolor enim voluptate dolore irure nulla culpa sint nulla do.",
            // buttonText: "Compare Our Plans",
            // rating: 4.85,
            // reviews: 14086,
        }

        , editMode = false
    } = appState

    if (!videoanimates) {
        return null
    }


    return (
        <Parallax className="home-video">
            <div className="iframeyoutube"><YouTubePlayer videoId={videoanimates.videoId} /></div>

            <div className="de-gradient-edge-top"></div>
            <div className="de-gradient-edge-bottom"></div>
            <div className="overlay-bg t50 no-top no-bottom">
                <div className="v-center">
                    <div className="container z-1000">
                        <div className="row align-items-center">
                            <div className="col-lg-10 offset-lg-1 text-center">
                                <div className="subtitle blink mb-4">{videoanimates.subtitle}</div>
                                <h1 className="mb-0 ">{videoanimates.title}</h1>
                            </div>
                            <div className="col-lg-6 offset-lg-3 text-center text-white">
                                <p className="">{videoanimates.description}</p>
                                {videoanimates.buttonText && <Link className="btn-main" to="/"
                                    onClick={() => {
                                        setAppState((existing) => {
                                            return {
                                                ...existing,
                                                showServices: true,
                                            };
                                        });
                                    }}>{videoanimates.buttonText}</Link>}

                                <div className="spacer-single"></div>

                                {/* <div className="de-rating-ext">
                                    <span className="d-stars">
                                        {[...Array(5)].map((_, i) => (
                                            <i key={i} className="fa fa-star"></i>
                                        ))}
                                    </span>
                                    <span className="d-val">{videoanimates.rating}</span>
                                    based on <strong>{videoanimates.reviews}</strong> reviews.
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Parallax>
    );
}

export default Section;
